import ApiClient from './ApiClient';

class TwoFactorMessages extends ApiClient {
  constructor() {
    super('two_factor_messages', { accountScoped: true });
  }
}

export default new TwoFactorMessages();
